// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"035ca239","453":"a1012599","866":"7487c3b2"}[chunkId] + ".chunk.js";
};